import React from 'react'

import { ZariContext } from '_zari/context'
import { Modal, Col, Row, Divider, Button, Table } from '_zari/core'

import * as PlantillaContabilidadService from 'services/plantillaContabilidad.service'

import { IdGen } from 'utils'

import * as FormGroups from './formGroups'
import * as Sections from './sections'

const CrudPlantillasModal = ({ show, handleClose, origen }) => {
  const __zariContext = React.useContext(ZariContext)

  const [sectionKey, setSectionKey] = React.useState(IdGen.newId())
  const [plantillas, setPlantillas] = React.useState([])

  const edicionDataRef = React.useRef({})

  const actualizarPlantillas = React.useCallback(() => {
    PlantillaContabilidadService.obtenerxOrigen(origen)
      .then(({ data }) => {
        if (data) {
          setPlantillas(data || [])
        }
      })
      .catch(() => {
        setPlantillas([])
      })
  }, [origen])

  React.useEffect(() => {
    actualizarPlantillas()
  }, [actualizarPlantillas])

  const clickEditar = React.useCallback(
    id => {
      PlantillaContabilidadService.getxIdAsEdicion(id)
        .then(({ data }) => {
          edicionDataRef.current = data
          setSectionKey(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.toast('error', error))
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    id => {
      PlantillaContabilidadService.eliminarxId(id)
        .then(() => {
          setSectionKey(IdGen.newId())
          actualizarPlantillas()
        })
        .catch(({ data: { error } }) => __zariContext.toast('error', error))
    },
    [__zariContext, actualizarPlantillas]
  )

  const refrescarSection = React.useCallback(() => {
    edicionDataRef.current = {}
    setSectionKey(IdGen.newId())
  }, [])

  return (
    <Modal show={show} size='xl'>
      <Modal.Header>
        <Modal.Title>Control Plantillas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <FormGroups.OrigenFormGroup value={origen} />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col md={6}>
            <Table
              filas={plantillas}
              maxRowsShown={10}
              headRows={[
                {
                  label: 'Descripcion'
                },
                {
                  label: 'Cuenta SOLES'
                },
                {
                  label: 'Cuenta DOLARES'
                },
                {
                  label: 'Cuenta EUROS'
                },
                {
                  label: ''
                }
              ]}
              rowTemplate={row => (
                <Table.Row key={row._id}>
                  <Table.Cell>{row.descripcion || '--'}</Table.Cell>
                  <Table.Cell>{row.cuentaContableSolesInfo || '--'}</Table.Cell>
                  <Table.Cell>{row.cuentaContableDolaresInfo || '--'}</Table.Cell>
                  <Table.Cell>{row.cuentaContableEurosInfo || '--'}</Table.Cell>
                  <Table.Cell>
                    <Table.Dropdown>
                      {({ handleClose }) => [
                        <Table.Dropdown.Item
                          key='editar-plantilla'
                          handleClose={handleClose}
                          onClick={() => clickEditar(row._id)}
                        >
                          Editar
                        </Table.Dropdown.Item>,
                        <Table.Dropdown.Item
                          key='eliminar-plantilla'
                          handleClose={handleClose}
                          onClick={() => clickEliminar(row._id)}
                        >
                          Eliminar
                        </Table.Dropdown.Item>
                      ]}
                    </Table.Dropdown>
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </Col>
          <Col md={6}>
            <Sections.CrearEditarPlantillaSection
              key={sectionKey}
              editarData={edicionDataRef.current}
              origen={origen}
              refrescarSection={refrescarSection}
              refrescarTabla={actualizarPlantillas}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' outline onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(CrudPlantillasModal)
